// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"534":"ac0b187a","995":"e7c95df0"}[chunkId] + ".chunk.js";
};